<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col items-center px-4 lg:px-0 pt-108-px pb-24 lg:pt-16 lg:pb-24 col-span-full md:col-start-2 md:col-end-8 lg:col-end-12"
    >
      <p
        class="text-3xl font-bold uppercase text-center lg:text-left"
        v-text="'LOREM IPSUM DOLOR SIT AMET'"
      />
      <p
        class="text-lg pt-16 lg:pt-6 max-w-187.5 text-center lg:text-left px-4 lg:px-0"
        v-text="
          'Lorem Ipsum is simply dummy textof the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s.'
        "
      />
      <section class="grid lg:grid-cols-2 pt-16 lg:pt-6 gap-x-6">
        <section class="w-full">
            <people-card />
        </section>
        <section v-if="!isMobile" class="w-full">
            <people-card />
        </section>
      </section>
    </section>
  </section>
</template>
<script>
import utilsMixin from "../mixins/utilsMixin";
export default {
  mixins: [utilsMixin],
  components: {
    PeopleCard: () => import("../components/PeopleCard.vue"),
  },
  props:{
    withBorder: {
      default: true
    }
  }
};
</script>
